import api from './api';

export interface UserAssistantConfig {
  id?: string;
  user_id?: string;
  outbound_assistant_id?: string;
  inbound_assistant_id?: string;
  outbound_phone_number_id?: string;
  agent_name?: string;
  // LT-379: per-user default Agent (FK → agents.id). Null/undefined =
  // fall back to workspace default at dispatch time.
  agent_id?: string | null;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface UserAssistantConfigCreate {
  outbound_assistant_id?: string;
  inbound_assistant_id?: string;
  outbound_phone_number_id?: string;
  agent_name?: string;
  agent_id?: string | null;
  is_active?: boolean;
}

export interface UserAssistantConfigUpdate {
  outbound_assistant_id?: string;
  inbound_assistant_id?: string;
  outbound_phone_number_id?: string;
  agent_name?: string;
  agent_id?: string | null;
  is_active?: boolean;
}

export interface ValidationResponse {
  is_valid: boolean;
  missing: string[];
  message: string;
}

export interface GlobalVoiceOptions {
  global_voice_id_male: string | null;
  global_voice_id_female: string | null;
}

class UserAssistantConfigService {
  private baseUrl = '/api/user-assistant-config';

  async getConfig(): Promise<UserAssistantConfig> {
    const response = await api.get(`${this.baseUrl}/`);
    return response.data;
  }

  async createConfig(config: UserAssistantConfigCreate): Promise<UserAssistantConfig> {
    const response = await api.post(`${this.baseUrl}/`, config);
    return response.data;
  }

  async updateConfig(config: UserAssistantConfigUpdate): Promise<UserAssistantConfig> {
    const response = await api.put(`${this.baseUrl}/`, config);
    return response.data;
  }

  async validateConfig(): Promise<ValidationResponse> {
    const response = await api.get(`${this.baseUrl}/validation`);
    return response.data;
  }

  async getGlobalVoiceOptions(): Promise<GlobalVoiceOptions> {
    const response = await api.get(`${this.baseUrl}/global-voice-options`);
    return response.data;
  }
}

export const userAssistantConfigService = new UserAssistantConfigService();
